"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregateStockKeysByStore = exports.getWarehousesKeysByStore = exports.isAggregated = exports.isWarehouse = void 0;
const isWarehouse = (name) => name.includes('MC');
exports.isWarehouse = isWarehouse;
const isAggregated = (name) => name.includes('VC');
exports.isAggregated = isAggregated;
const storeToWarehousesKeys = {
    uk: ['MC01'],
    us: ['MC02'],
    ca: ['MC02'],
    roi: ['MC01'],
    'outlet-uk': ['MC05'],
    //  STAR 2 stores
    fr: ['MC01'],
    de: ['MC01'],
    es: ['MC01'],
    it: ['MC01'],
    nl: ['MC01'],
    'roe-sm': ['MC01'],
    'roe-lu': ['MC01'],
    'roe-at': ['MC01'],
    'roe-scand': ['MC01'],
    'roe-be': ['MC01'],
    'roe-dk': ['MC01'],
    'roe-pl': ['MC01'],
    'roe-ch': ['MC01'],
    roe: ['MC01'],
};
function getWarehousesKeysByStore(store) {
    return storeToWarehousesKeys[store] || [];
}
exports.getWarehousesKeysByStore = getWarehousesKeysByStore;
const storeToAggregateStockKeys = {
    uk: ['VS01'],
    us: ['VS02', 'DC14', 'DC15'],
    'outlet-uk': ['VS01_OUTLET'],
};
function getAggregateStockKeysByStore(store) {
    return storeToAggregateStockKeys[store] || [];
}
exports.getAggregateStockKeysByStore = getAggregateStockKeysByStore;
//# sourceMappingURL=inventories.js.map